import React from "react";
import { HiOutlineMoon, HiOutlineSun } from "react-icons/hi";
import { useI18n } from "../../i18n/I18nProvider";
import { useTheme } from "../../theme/ThemeProvider";

const ThemeToggle = () => {
  const { t } = useI18n();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-pressed={isDark}
      aria-label={isDark ? t("nav.themeLight") : t("nav.themeDark")}
      className="inline-flex h-11 w-11 items-center justify-center rounded-pill border border-hairline bg-canvas text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
    >
      {isDark ? <HiOutlineSun size={18} /> : <HiOutlineMoon size={18} />}
    </button>
  );
};

export default ThemeToggle;
